import React, { useState } from 'react';

function QuestionContent2({ onNext, onBack }) {
  const [question, setQuestion] = useState(''); // State to track the textarea value
  const [selectedFiles, setSelectedFiles] = useState([]); // State to track the selected files
  const [fileNames, setFileNames] = useState([]); // State to track the file names
  const [error, setError] = useState(false); // Error state for validation
  const [loading, setLoading] = useState(false); // Optional: for managing loading state
  const [apiError, setApiError] = useState(null); // Optional: for handling API errors

  // Handle textarea input
  const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };

  // Handle file selection
  const selectFiles = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    setFileNames(files.map((file) => file.name));
  };

  // Submit the form data to the backend API
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page refresh

    // Validate input fields
    if (!question || selectedFiles.length === 0) {
      setError('Please fill the textarea and upload a file to continue');
      return;
    }
    setError(false); // Clear any previous errors

    setLoading(true); // Show loading state
    setApiError(null); // Reset API error state
    const data = {
      question,
      selectedFiles
    }
    onNext({data});
  };

 

  return (
    <div className='r-content'>
      <div className="content-text">
        Enter your question in the box. If you want to ask a question anonymously, avoid providing information that could reveal your identity.
      </div>
      <form method="POST" className="questionform" onSubmit={handleSubmit}>
        <div className="fill-opt1 fill-textarea">
          <p>Question</p>
          <textarea
            name="question"
            id="question"
            rows={5}
            value={question}
            onChange={handleQuestionChange} // Track textarea changes
          ></textarea>
        </div>
        <div className="file-uploader">
          <input
            type="file"
            id="file-input"
            // multiple
            onChange={selectFiles} // Track selected files
            style={{ display: 'none' }}
          />
          <label htmlFor="file-input" className="custom-file-button">
            Attach Files
          </label>
          <p>{fileNames.length > 0 ? fileNames.join(', ') : ' '}</p>
        </div>
        <div className="content-text">
          If you want to upload more than one file, please select multiple files by holding the Control key and clicking on the files you want to upload. Before attaching files, check their metadata, which may reveal your identity.
        </div>
        
        {error && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
        {apiError && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{apiError}</div>} {/* Display API error */}

        <div className="back-next">
          <button type="button" className="Backbtn" onClick={onBack}>Back</button>
          <button type="submit" className="Nextbtn" >next</button>
        </div>
      </form>
    </div>
  );
}

export default QuestionContent2;
